<template>
  <div class="result-page">
    <main class="result-stage">
      <div class="result-title">
        <h1>证书查询结果</h1>
        <p>Certificate Query Result</p>
      </div>

      <section class="result-card" v-if="info">
        <div class="status-mark">√</div>
        <div class="success-copy">
          <h2>查询成功</h2>
          <p>已找到对应的证书信息</p>
        </div>

        <div class="result-grid">
          <div v-for="row in resultRows" :key="row.label" class="result-item">
            <div class="label">{{ row.label }}</div>
            <div class="value">{{ row.value || "-" }}</div>
          </div>
        </div>

        <button class="again" type="button" @click="$router.push('/infoQuery')">
          返回查询
        </button>
      </section>
    </main>
  </div>
</template>

<script>
import { Message } from "element-ui";

export default {
  name: "InfoQueryResult",
  data() {
    return {
      info: null,
    };
  },
  computed: {
    resultRows() {
      if (!this.info) return [];
      return [
        { label: "姓名", value: this.info.name },
        { label: "性别", value: this.info.sex },
        { label: "证件类型", value: this.info.cardtype },
        { label: "身份证号", value: this.info.cardid },
        { label: "出生日期", value: this.info.birthday },
        { label: "学历", value: this.info.edu },
        { label: "申报专业", value: this.info.declareMajor },
        { label: "申报级别", value: this.info.declareLevel },
        { label: "证书编号", value: this.info.certid },
        { label: "发证日期", value: this.info.issueDate },
        { label: "工作单位", value: this.info.workUnit },
      ];
    },
  },
  mounted() {
    this.$axios
      .get(`/api/infoQuery/${this.$route.params.id}`)
      .then((res) => {
        this.info = res.data.data;
      })
      .catch(() => {
        Message.error("未查询到相关证书信息");
        this.$router.replace("/infoQuery");
      });
  },
};
</script>

<style scoped>
.result-page {
  position: relative;
  min-height: 100vh;
  background: #f4fbff;
  overflow: hidden;
}

.result-page:before,
.result-page:after {
  content: "";
  position: absolute;
  top: 48px;
  width: 560px;
  height: 910px;
  background: url("/static/img/info-query/figma/result-dots-mobile-6e8e630.png") center/contain
    no-repeat;
  opacity: 0.82;
  pointer-events: none;
}

.result-page:before {
  left: -162px;
}

.result-page:after {
  right: -162px;
  transform: scaleX(-1);
}

.result-stage {
  position: relative;
  z-index: 1;
  min-height: 100vh;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 42px 20px 54px;
  box-sizing: border-box;
}

.result-title {
  margin-bottom: 48px;
  text-align: center;
}

.result-title h1 {
  margin: 0;
  color: #118ff1;
  font-size: 48px;
  line-height: 58px;
  font-weight: 700;
  letter-spacing: 0;
}

.result-title p {
  margin: 10px 0 0;
  color: rgba(17, 143, 241, 0.72);
  font-size: 16px;
  line-height: 22px;
}

.result-card {
  position: relative;
  width: 1180px;
  min-height: 626px;
  padding: 76px 52px 38px;
  background: rgba(255, 255, 255, 0.98);
  border: 2px solid rgba(36, 157, 248, 0.78);
  border-radius: 18px;
  box-shadow: 0 16px 38px rgba(37, 139, 205, 0.12);
  box-sizing: border-box;
}

.result-card:before {
  content: "";
  position: absolute;
  left: 50%;
  top: 150px;
  width: 420px;
  height: 420px;
  transform: translateX(-50%);
  background: url("/static/img/info-query/figma/seal-240c384f.png") center/contain no-repeat;
  opacity: 0.075;
  pointer-events: none;
}

.success-copy {
  position: relative;
  z-index: 1;
  text-align: center;
  margin-bottom: 50px;
}

.success-copy h2 {
  margin: 0;
  color: #253044;
  font-size: 24px;
  line-height: 32px;
}

.success-copy p {
  margin: 10px 0 0;
  color: #8b97a7;
  font-size: 14px;
  line-height: 20px;
}

.status-mark {
  position: absolute;
  left: 50%;
  top: -31px;
  transform: translateX(-50%);
  width: 62px;
  height: 62px;
  border-radius: 50%;
  background: #15c184;
  color: #fff;
  text-align: center;
  line-height: 62px;
  font-size: 42px;
  font-weight: 700;
  box-shadow: 0 8px 15px rgba(21, 193, 132, 0.3);
}

.result-grid {
  position: relative;
  z-index: 1;
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  column-gap: 43px;
  row-gap: 31px;
  margin: 0;
}

.result-item {
  min-width: 0;
}

.label {
  position: relative;
  color: #6d7a89;
  text-align: left;
  font-size: 14px;
  line-height: 20px;
  padding-left: 25px;
}

.label:before {
  content: "";
  position: absolute;
  left: 0;
  top: 6px;
  width: 10px;
  height: 10px;
  border-radius: 50%;
  background: #168ff0;
  box-shadow: 0 0 0 6px rgba(22, 143, 240, 0.12);
}

.value {
  min-height: 50px;
  border-bottom: 1px solid #dbeafa;
  padding: 8px 0 14px 25px;
  color: #101f2d;
  font-size: 17px;
  line-height: 24px;
  font-weight: 600;
  word-break: break-all;
  box-sizing: border-box;
}

.again {
  position: relative;
  z-index: 1;
  display: block;
  width: 236px;
  height: 52px;
  margin: 48px auto 0;
  border: 0;
  border-radius: 10px;
  background: linear-gradient(90deg, #2488ff 0%, #00b7d8 100%);
  box-shadow: 0 8px 14px rgba(17, 139, 225, 0.25);
  color: #fff;
  font-size: 16px;
  cursor: pointer;
}

@media (max-width: 640px) {
  .result-page {
    background: #f4fbff;
  }

  .result-page:before,
  .result-page:after {
    top: 0;
    width: 250px;
    height: 760px;
    background-image: url("/static/img/info-query/figma/result-dots-small-e0cf0b2.png");
    opacity: 0.74;
  }

  .result-page:before {
    left: -118px;
  }

  .result-page:after {
    right: -118px;
  }

  .result-stage {
    align-items: center;
    justify-content: flex-start;
    padding: 58px 22px 36px;
  }

  .result-title {
    width: 100%;
    margin-bottom: 42px;
  }

  .result-title h1 {
    font-size: 28px;
    line-height: 36px;
  }

  .result-title p {
    font-size: 12px;
    line-height: 18px;
  }

  .result-card {
    width: 100%;
    max-width: 315px;
    min-height: 620px;
    padding: 48px 23px 30px;
    border-radius: 12px;
    border-width: 1px;
  }

  .result-card:before {
    top: 160px;
    width: 230px;
    height: 230px;
    opacity: 0.055;
  }

  .success-copy {
    margin-bottom: 26px;
  }

  .success-copy h2 {
    font-size: 16px;
    line-height: 22px;
  }

  .success-copy p {
    margin-top: 5px;
    font-size: 12px;
    line-height: 18px;
  }

  .status-mark {
    width: 46px;
    height: 46px;
    top: -23px;
    line-height: 46px;
    font-size: 32px;
  }

  .result-grid {
    grid-template-columns: 1fr;
    row-gap: 10px;
    column-gap: 0;
  }

  .label,
  .value {
    font-size: 12px;
    line-height: 18px;
  }

  .value {
    padding: 4px 0 10px 25px;
  }

  .again {
    width: 100%;
    height: 36px;
    margin-top: 24px;
  }
}
</style>
